import {VehiclesMappersFactory} from '../../vehicles/Mappers/factory.js'
import SeoMappersFactory from '../Mappers/factory.js'
import {SeoRepositoriesFactory} from '../Repositories/factory.js'
import {GetSeoDataService} from './GetSeoDataService.js'
import {GetTagcloudSeoService} from './GetTagcloudSeoService.js'

export default class SeoServicesFactory {
  static getSeoDataService = ({config}) =>
    new GetSeoDataService({
      config,
      mapperFactory: SeoMappersFactory.seoMetaInformationMapper({
        config
      })
    })

  static getTagcloudSeoService = ({config}) =>
    new GetTagcloudSeoService({
      config,
      fromJsonToTagCloudSeoRequestSeoMapper: SeoMappersFactory.fromJsonToTagCloudSeoRequestSeoMapper,
      fromListVOToTagcloudListVOSeoMapper: SeoMappersFactory.fromListVOToTagcloudListVOSeoMapper({config}),
      fromMakesJsonToMakesListVOVehiclesMapper: VehiclesMappersFactory.fromMakesJsonToMakesListVOVehiclesMapper({
        config
      }),
      fromModelsJsonToSubscriptionModelsListVOVehiclesMapper:
        VehiclesMappersFactory.fromModelsJsonToSubscriptionModelsListVOVehiclesMapper({
          config
        }),
      httpSeoRepository: SeoRepositoriesFactory.hTTPSeoRepository({config})
    })
}
